import { render } from "./brand-title.vue.js?vue&type=template&id=07cdde81!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./brand-title.vue?vue&type=template&id=07cdde81"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__